import React from 'react';
import { useTranslation } from 'react-i18next';

import { useModal } from '@private/modals';

import { IReports } from 'components/Downloads/types';
import { AdaptiveModalContainer } from 'routes/pages/AuthorizedStack/styled';

import ReportGrid from './ReportGrid';
import ReportTabs from './ReportTabs';
import { Content } from './styled';

export interface IReportsModalProps {
  closeModal: () => void;
  reports: IReports[];
}

const ReportsModal = ({ closeModal, reports }: IReportsModalProps) => {
  const { t } = useTranslation();

  return (
    <AdaptiveModalContainer
      hideFooter
      onDismiss={closeModal}
      testIds={{ container: 'reportsModal' }}
      title={t('common.reports')}
    >
      <Content>
        {reports.length === 1 ? (
          <ReportGrid path={reports[0].path} refreshMargin>
            {({ content, createComponent }) => (
              <>
                {createComponent}
                {content}
              </>
            )}
          </ReportGrid>
        ) : (
          <ReportTabs reports={reports} />
        )}
      </Content>
    </AdaptiveModalContainer>
  );
};

type TUseConfirmModalResult = [(reports: IReports[]) => void, () => void];

export const useReportsModal = (): TUseConfirmModalResult => {
  const { closeModal, showModal } = useModal();

  const showReportsModal = React.useCallback((reports: IReports[]) => {
    showModal(<ReportsModal closeModal={closeModal} reports={reports} />);
  }, []);

  return [showReportsModal, closeModal];
};
